exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CueTooltip-471ab85a{width:max-content;max-width:200px}@media all and (-ms-high-contrast: none), (-ms-high-contrast: active){.CueTooltip-471ab85a{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}}@supports (-ms-ime-align: auto){.CueTooltip-471ab85a{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}}\n", ""]);

// Exports
exports.locals = {
	"CueTooltip": "CueTooltip-471ab85a"
};